import { confirmed, hidden, underReview } from '../../constants/clientConfig';

/**
 * Normalizes client config status from API / Redux (string or number) to an integer or null.
 *
 * @param {string|number|null|undefined} configStatus
 * @returns {number|null}
 */
export function parseOnboardingConfigStatusId(configStatus) {
    if (configStatus === null || configStatus === undefined || configStatus === '') {
        return null;
    }
    const s = parseInt(String(configStatus), 10);
    if (Number.isNaN(s)) {
        return null;
    }
    return s;
}

/**
 * True when onboarding placement structure / roster should be treated as locked (not draft).
 *
 * @param {string|number|null|undefined} configStatus
 * @returns {boolean}
 */
export function isOnboardingStructureLocked(configStatus) {
    const s = parseOnboardingConfigStatusId(configStatus);
    if (s === null) {
        return false;
    }
    return [underReview, confirmed, hidden].includes(s);
}
